document.addEventListener('DOMContentLoaded', function () {
  $(document).on('change', '[data-auto-submit=true]', function () {
    $(this).closest('form').submit()
  })
})
